
import React from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import {
  Grip,
  Check,
  PlusCircle,
  RotateCcw,
  Save,
} from "lucide-react";
import { useEnhancedTranslation } from "@/hooks/useEnhancedTranslation";

interface DashboardControlsProps {
  handlesVisible: boolean;
  toggleHandlesVisibility: () => void;
  saveLayoutToDatabase: () => void;
  resetDashboardLayout: () => void;
  isSaving: boolean;
  savedToDb: boolean;
  openWidgetsModal: () => void;
}

export function DashboardControls({
  handlesVisible,
  toggleHandlesVisibility,
  saveLayoutToDatabase,
  resetDashboardLayout,
  isSaving,
  savedToDb,
  openWidgetsModal,
}: DashboardControlsProps) {
  const { t } = useEnhancedTranslation();

  return (
    <Card className="p-3 mb-4">
      <div className="flex flex-wrap gap-2 items-center">
        <Button
          size="sm"
          variant={handlesVisible ? "default" : "outline"}
          onClick={toggleHandlesVisibility}
        >
          <Grip className="w-4 h-4 mr-2" />
          {handlesVisible ? t('dashboard.controls.editing', 'Editing') : t('dashboard.controls.editLayout', 'Edit Layout')}
        </Button>

        {handlesVisible && (
          <>
            <Button size="sm" variant="outline" onClick={openWidgetsModal}>
              <PlusCircle className="w-4 h-4 mr-2" />
              {t('dashboard.controls.addWidget', 'Add Widget')}
            </Button>

            <Button
              size="sm"
              variant="outline"
              onClick={resetDashboardLayout}
              className="text-red-500 hover:text-red-700"
            >
              <RotateCcw className="w-4 h-4 mr-2" />
              {t('dashboard.controls.resetLayout', 'Reset Layout')}
            </Button>

            <Button
              size="sm"
              variant={savedToDb ? "secondary" : "default"}
              onClick={saveLayoutToDatabase}
              disabled={isSaving}
            >
              {savedToDb ? (
                <Check className="w-4 h-4 mr-2" />
              ) : (
                <Save className="w-4 h-4 mr-2" />
              )}
              {isSaving
                ? t('dashboard.controls.saving', 'Saving...')
                : savedToDb
                ? t('dashboard.controls.saved', 'Saved!')
                : t('dashboard.controls.saveLayout', 'Save Layout')}
            </Button>
          </>
        )}
      </div>
    </Card>
  );
}
